import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { GroupType, MaskTextInput, ModuleOrganization } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Constants from "constants/index";
import Screens from "constants/screens";
import Strings from "constants/strings";

import { RootState } from "store";
import { BooleanInt, Mode } from "constants/enum";
import { DashboardLayout } from "layout";
import { setListPathName } from "store/slice/titleRoute.slice";
import { useAuth } from "providers/authProvider";


interface IRequestGetPaged {
    orderby?: string;
    pageSize?: number;
    pageNumber?: number;
    totalCount?: number;
    searchText?: string;
    status?: string[];
    organizationCode?: string;
}

const OrganizationScreen = () => {

    const auth = useAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const id = searchParams.get("id");
    const modeList = (Screens.ORGANIZATION_LIST.includes(window.location.pathname));
    const pramsMode = !Helpers.isNullOrEmpty(searchParams.get("mode")) ? Number(searchParams.get("mode")) : undefined;

    const user = useSelector((state: RootState) => state.user);
    const listPathName = useSelector((state: RootState) => state.titleRoute.listPathName);

    const itemPathName = listPathName.find(el => el.pathName === Screens.ORGANIZATION_LIST);

    const [model, setModel] = useState<any>({});
    const [requestData] = useState<IRequestGetPaged>({
        status: searchParams.getAll("status"),
        searchText: searchParams.get("searchText"),
        pageNumber: Number(searchParams.get("pageNumber") || 1),
        organizationCode: searchParams.get("organizationCode") || undefined,
        pageSize: Number(searchParams.get("pageSize") || Constants.ROW_PER_PAGE),
        totalCount: itemPathName?.totalCount,
    } as IRequestGetPaged);

    useEffect(() => {
        if (Helpers.isNullOrEmpty(id)) {
            handleChangeMode(Mode.Create);
        } else {
            let mode: number = pramsMode || Mode.Update;
            handleChangeMode(mode);
        }
    }, [id, pramsMode]);


    const handleGoBack = () => {
        const itemP = listPathName.find((el) => el.pathName === Screens.ORGANIZATION_LIST);
        navigate(Screens.ORGANIZATION_LIST + (itemP ? itemP.query : ""));
    };

    const handleChangeMode = (value: Mode) => {
        let title: string = "";
        let route = [{ title: Strings.ORGANIZATION.TITLE_MENU, route: Screens.ORGANIZATION_LIST }];

        if (value === Mode.Create) {
            title = Strings.ORGANIZATION.TITLE_CREATE_VIEW;
            route = [
                { title: Strings.ORGANIZATION.TITLE_MENU, route: Screens.ORGANIZATION_LIST },
                { title: Strings.COMMON.ADD_NEW, route: "" },
            ];
        }
        if (value === Mode.Update) {
            title = Strings.ORGANIZATION.TITLE_UPDATE_VIEW;
            route = [
                { title: Strings.ORGANIZATION.TITLE_MENU, route: Screens.ORGANIZATION_LIST },
                { title: Strings.COMMON.UPDATE, route: "", },
            ];
        }
        if (value === Mode.View) {
            title = Strings.ORGANIZATION.TITLE_DETAIL_VIEW;
            route = [
                { title: Strings.ORGANIZATION.TITLE_MENU, route: Screens.ORGANIZATION_LIST },
                { title: Strings.COMMON.VIEW_DETAIL, route: "", },
            ];
        }

        setModel({
            ...model,
            mode: value,
            title: title,
            route: route,
        });

        if (!Helpers.isNullOrEmpty(id)) {
            navigate(Screens.ORGANIZATION_DETAIL + `?id=${id}&mode=${value}`, { replace: true });
        }
    }

    return (
        <DashboardLayout
            isPermission
            allowSettingLayout
            title={modeList ? Strings.ORGANIZATION.TITLE_LIST_VIEW : model.title}
            route={modeList ? [{ title: Strings.ORGANIZATION.TITLE_MENU, route: "" }] : model.route}
        >
            <ModuleOrganization
                keyModuleContainer={{
                    list: { pathName: Screens.ORGANIZATION_LIST },
                    detail: { pathName: Screens.ORGANIZATION_DETAIL },
                    create: { pathName: Screens.ORGANIZATION_CREATE },
                }}

                groupLabel={Strings.COMMON.DEPARTMENT}
                staffLabel={Strings.COMMON.STAFF}
                
                hiddenActionCreateStaff
                hiddenActionCreateGroup
                organizationCode={{
                    visible: true,
                    label: Strings.ORGANIZATION.CODE
                }}
                // allowActionImportStaff
                // allowActionImportGroup

                userRole={{
                    ignoreHierarchy: BooleanInt.True
                }}

                unCheckGeneGroup
                showOrganizationCode
                allowActionResetPassword
                hiddenActionInvationStaff
                getAddressByGeographic
                getUserNonHierarchical
                getGroupNonHierarchical
                groupTypeImport={GroupType.Department}

                requestGetPaged={requestData}
                onGetPaged={async ({ query, totalCount }) => {
                    dispatch(setListPathName({ pathname: Screens.ORGANIZATION_LIST, query, totalCount: totalCount }));
                    navigate(Screens.ORGANIZATION_LIST + query, { replace: true });
                }}
                onUpdateListOrganization={async ({ data, isFetchUserInfo }) => {
                    if (isFetchUserInfo) {
                        Helpers.setItemInLocalStorage(Constants.StorageKeys.ORGANIZATION_ID, "");
                    };
                    const notOrg = Helpers.isNullOrEmpty(user?.workingOrganization) || (user?.workingOrganization === "0");
                    if (data.length > 0 && notOrg) {
                        const itemLast = data[data.length - 1];
                        Helpers.setItemInLocalStorage(Constants.StorageKeys.ORGANIZATION_ID, itemLast?.code);

                        await auth.signinRedirect({
                            "organization_id": itemLast?.code,
                            "active_user": user?.userInfo?.userProfile?.identityId,
                        });
                    }
                }}
                onNavigate={async (data) => {
                    if (data.id) {
                        navigate(Screens.ORGANIZATION_DETAIL + `?id=${data.id}&mode=${data.mode}`);
                    } else {
                        navigate(Screens.ORGANIZATION_CREATE);
                    }
                }}

                idDetail={id}
                mode={model.mode}
                onGoBack={handleGoBack}
                onChangeMode={(value) => { handleChangeMode(value) }}
            />
        </DashboardLayout>
    );
};

export default OrganizationScreen;
